import React from 'react';
import { Link } from 'react-router-dom';

function PaymentFailurePage() {
    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.iconError}>
                    <i className="bi bi-x-circle-fill" style={{ fontSize: '4rem' }}></i>
                </div>

                <h1 style={styles.title}>Pagamento Não Aprovado</h1>

                <p style={styles.message}>
                    Infelizmente não foi possível processar seu pagamento.
                    Por favor, tente novamente ou entre em contato com o suporte.
                </p>

                <div style={styles.info}>
                    <h3 style={{ marginBottom: '1rem', color: '#2d3748' }}>Possíveis causas:</h3>
                    <p>• Dados do cartão incorretos</p>
                    <p>• Saldo insuficiente</p>
                    <p>• Limite do cartão excedido</p>
                    <p>• Cartão bloqueado</p>
                </div>

                <Link to="/pagamento" style={styles.button}>
                    Tentar Novamente
                </Link>

                <Link to="/planos" style={styles.linkSecondary}>
                    Ver planos disponíveis
                </Link>

                <Link to="/dashboard" style={styles.linkSecondary}>
                    Voltar ao dashboard
                </Link>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '2rem',
    },
    card: {
        background: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    },
    iconError: {
        color: '#e53e3e',
        marginBottom: '1.5rem',
    },
    title: {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#2d3748',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1.1rem',
        color: '#718096',
        marginBottom: '2rem',
        lineHeight: '1.6',
    },
    info: {
        background: '#fff5f5',
        border: '1px solid #feb2b2',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '2rem',
        textAlign: 'left',
    },
    button: {
        display: 'inline-block',
        padding: '1rem 2rem',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: '600',
        fontSize: '1.1rem',
        marginBottom: '1rem',
    },
    linkSecondary: {
        display: 'block',
        color: '#667eea',
        textDecoration: 'none',
        marginTop: '1rem',
    },
};

export default PaymentFailurePage;
